import * as React from 'react';

export function If(props)  {
    return <React.Fragment>{props.show ? props.children : null}</React.Fragment>;
}
export default If;